// RMSCheckbox.jsx

import React from 'react';
import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

const RMSCheckbox = ({
  name,
  label,
  disabled = false,
  className = '',
  checkboxClassName = '',
  labelClassName = '',
  onChange,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            className={`${className} ${labelClassName}`}
            control={
              <Checkbox
                checked={field.value || false}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                  onChange?.(e);
                }}
                onBlur={field.onBlur}
                color="primary"
                disabled={disabled || field.disabled}
                className={checkboxClassName}
              />
            }
            label={label}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default RMSCheckbox;
